<script setup lang="ts">
/**
 * « Donoor » en très grand au pied de page, gravé noir sur noir (Karim
 * 2026-10-13, inspiré de trove.quest) : toute la largeur du conteneur, le bas
 * des lettres coupé par le bord de la page. Purement décoratif (aria-hidden).
 *
 * SVG plutôt que du texte HTML : `textLength` + `lengthAdjust="spacing"` cale
 * le mot sur la largeur EXACTE du conteneur sans déformer les lettres (seul
 * l'espacement s'ajuste), quelle que soit la taille de l'écran.
 */
const uid = useId();
</script>

<template>
  <UContainer class="pointer-events-none select-none" aria-hidden="true">
    <svg
      viewBox="0 0 1000 232"
      class="block w-full h-auto"
      preserveAspectRatio="xMidYMax meet"
      role="presentation"
    >
      <defs>
        <!-- Face des lettres : gris nettement visible sur le noir, plus sombre en
             bas (Karim 2026-10-13 : « on ne le voit pas assez »). -->
        <linearGradient :id="`${uid}-face`" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stop-color="#4a4a4a" />
          <stop offset="1" stop-color="#1e1e1e" />
        </linearGradient>
      </defs>
      <!-- Reflet du haut (léger décalage) puis la lettre : effet gravé. -->
      <text
        x="0"
        y="282"
        textLength="1000"
        lengthAdjust="spacing"
        class="nom"
        fill="none"
        stroke="rgb(255 255 255 / 0.3)"
        stroke-width="2"
        transform="translate(0 -2)"
      >Donoor</text>
      <text
        x="0"
        y="282"
        textLength="1000"
        lengthAdjust="spacing"
        class="nom"
        :fill="`url(#${uid}-face)`"
        stroke="rgb(255 255 255 / 0.16)"
        stroke-width="1"
      >Donoor</text>
    </svg>
  </UContainer>
</template>

<style scoped>
.nom {
  font-family: "MD Nichrome Dark", var(--font-display), sans-serif;
  font-size: 330px;
  letter-spacing: -0.01em;
}
</style>
